<template>
  <div>
    <div class="father">
      <div>
        <h1>Main heading</h1>
        <h2>Sub heading</h2>
      </div>
      <div>
        <article>
          <img src="../../../static/img/企事业餐饮运营托管服务1.jpg" />
          <h2></h2>
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">01</p>
              <div>
                <p class="title">采购管理</p>
                <p class="subtitle">严格的供应商索证制度，</p>
                <p class="subtitle">规范化的检测验收流程。</p>
              </div>
            </div>
            <p class="item_content">制定采购计划</p>
            <p class="item_content">下达物料</p>
            <p class="item_content">选择供应商</p>
            <p class="item_content">索要各类证书</p>
            <p class="item_content">采购物资审批</p>
            <p class="item_content">保鲜运输方式</p>
            <p class="item_content">按标准验收</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/企事业餐饮运营托管服务2.jpg" />
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">02</p>
              <div>
                <p class="title">存储管理</p>
                <p class="subtitle">严格分类存放，进出有序；</p>
                <p class="subtitle">杜绝过期食品。</p>
              </div>
            </div>
            <p class="item_content">分类及时入库</p>
            <p class="item_content">建立入库档案</p>
            <p class="item_content">科学存放</p>
            <p class="item_content">凭单出库</p>
            <p class="item_content">进出有序</p>
            <p class="item_content">每日盘点</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/企事业餐饮运营托管服务3.jpg" />
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">03</p>
              <div>
                <p class="title">洗消管理</p>
                <p class="subtitle">分类多次清洗，</p>
                <p class="subtitle">设施干净卫生。</p>
              </div>
            </div>
            <p class="item_content">农残检测</p>
            <p class="item_content">去皮去根</p>
            <p class="item_content">分类清洗</p>
            <p class="item_content">盐水浸泡</p>
            <p class="item_content">两次清洗</p>
            <p class="item_content">即洗即用</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/企事业餐饮运营托管服务4.jpg" />
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">04</p>
              <div>
                <p class="title">加工管理</p>
                <p class="subtitle">规范化工作流程，</p>
                <p class="subtitle">科学化搭配与加工方案。</p>
              </div>
            </div>
            <p class="item_content">生熟分开</p>
            <p class="item_content">荤素分开</p>
            <p class="item_content">合理搭配</p>
            <p class="item_content">及时清理卫生</p>
            <p class="item_content">定时消毒</p>
            <p class="item_content">流程规范</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/企事业餐饮运营托管服务5.jpg" />
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">05</p>
              <div>
                <p class="title">监督管理</p>
                <p class="subtitle">实行岗位责任制，</p>
                <p class="subtitle">48小时食品留样。</p>
              </div>
            </div>
            <p class="item_content">岗位责任制</p>
            <p class="item_content">营养搭配</p>
            <p class="item_content">安全卫生</p>
            <p class="item_content">留样48小时</p>
            <p class="item_content">菜品中心温度75℃</p>
            <p class="item_content">操作规范</p>
          </div>
        </article>
        <article>
          <h2></h2>
          <img src="../../../static/img/企事业餐饮运营托管服务6.jpg" />
          <div class="content_div">
            <div class="item_div">
              <p class="num_title">06</p>
              <div>
                <p class="title">售卖管理</p>
                <p class="subtitle">售餐人员严格按照标准着装，</p>
                <p class="subtitle">统一佩戴口罩、手套。</p>
              </div>
            </div>
            <p class="item_content">统一着装</p>
            <p class="item_content">佩戴口罩</p>
            <p class="item_content">束发戴帽</p>
            <p class="item_content">佩戴一次性手套</p>
            <p class="item_content">微笑贴心服务</p>
            <p class="item_content">客户第一</p>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  computed: {},
  mounted() {},
  destroyed() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.father {
  width: 100%;
  height: 72rem;
  margin: 5rem auto;

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  * {
    transition: all 0.3s ease 0s;
  }

  .content_div {
    height: 100%;
    width: 100%;
    background: var(--textBlue60);
    position: absolute;
    padding:8rem 4rem;
    top: 0;

    h3 {
      margin: 5rem 0 0 5rem;
      font-size: 3rem;
      font-family: bold;
    }

    p {
      margin: 0 5rem 0 5rem;
      width: auto;
      font-size: 1.8rem;
      font-family:light;
    }

    .first_p {
      margin: 5rem 5rem 0 5rem;
    }

    .item_div {
      display: flex;
      position: relative;
      width: fit-content;
      top: 0;
      margin:0 auto 2rem;
      background: transparent;
      align-items: center;

      div{
        width:fit-content;
      }
      .num_title {
        font-size: 8rem;
        font-family: number;
        margin:0 3rem;
      }

      .title {
        font-size: 2.5rem;
        font-family: regular;
        margin:0;
      }

      .subtitle {
        font-size: 1.3rem;
        font-family: light;
        margin:0;
      }
    }

    .item_content {
      height:6.5rem;
      width:33rem;
      background-image :url('../../../static/img/餐饮2bannerbg.png')
      background-repeat :no-repeat;
      background-size: contain;
      font-size: 2rem;
      font-family: regular;
      line-height :5rem;
      color: var(--textGary80);
      text-align: center;
      position relative;
      margin:auto;
    }
  }

  /* Background colours */
  div + div article:nth-child(1) {
    // background: #00c22326;
    // background-image: url('../../static/img/切片-38.jpg');
    background-repeat: no-repeat;
  }

  div + div article:nth-child(2) {
    // background: #f37338;
    // background-image: url('../../static/img/切片-39.jpg');
  }

  div + div article:nth-child(3) {
    // background: #fdb632;
    // background-image: url('../../static/img/切片-40.jpg');
  }

  div + div article:nth-child(4) {
    // background: #027878;
    // background-image: url('../../static/img/切片-41.jpg');
  }

  div + div article:nth-child(5) {
    // background: #801638;
    // background-image: url('../../static/img/切片-42.jpg');
  }

  div + div article:nth-child(6), div + div {
    // background: #800000;
    // background-image: url('../../static/img/切片-43.jpg');
    // height:100%;
    // background-repeat: no-repeat;
  }

  /* Main layout */
  html, body, div + div {
    width: 100%;
    height: 100%;
  }

  div + div {
    list-style: none;
    position: relative;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    overflow: hidden;
  }

  /* Articles */
  div + div article {
    flex: initial;
    width: 17%;
    height: 100%;
    text-align: center;
    color: #fff;
    text-decoration: none;
    vertical-align: bottom;
    box-sizing: border-box;
    // padding: 2vh 1vw;
    position: relative;
  }

  /* Big Headings */
  div:first-child {
    display: none;
    position: fixed;
    bottom: 8vh;
    background: #fff;
    width: 100%;
    text-align: center;
    padding: 0.5rem;
    z-index: 2;
  }

  div:first-child h1, div:first-child h2 {
    margin: 0;
    padding: 0;
  }

  /* Hover interaction */
  div + div:hover article {
    flex: initial;
    width: 10%;
  }

  div + div article:hover {
    width: 50%;
  }

  article > div {
    opacity: 0;
    transition: opacity 0.2s ease 0;
  }

  div + div article:hover > div {
    opacity: 1;
    transition: opacity 0.3s ease 0.3s;
  }

  /* navigation */
  div + div article > h2 {
    bottom: 2vh;
    position: absolute;
    text-align: center;
    width: 100%;
    margin: 0;
    font-size: 3vh;
  }

  /* Article layouts */
  article div {
    text-align: left;
    width: 58vw;
  }

  article div p, article div div h2, article div h3 {
    margin: 0 0 1em 0;
  }

  h1, h2, h3, h4, h5, h6 {
    text-transform: uppercase;
  }

  article div p {
    width: 40vw;
  }

  @media (min-width: 1300px) {
    .litter_line {
      margin: 4rem 5rem 1rem 5rem;
    }

    .content_div {
      h3 {
        margin: 5rem 0 0 5rem;
      }

      p {
        margin: 0 5rem 0 5rem;
      }

      .first_p {
        margin: 5rem 5rem 0 5rem;
      }
    }
  }

  @media (max-width: 900px) {
    div + div article {
      padding: 2vh 3vw;
    }

    div + div article > h2 {
      transform: rotate(90deg);
      bottom: 23vh;
      min-width: 12em;
      text-align: left;
      transform: rotate(-90deg);
      transform-origin: 0 0 0;
      opacity: 1;
    }

    div + div article:hover > h2 {
      opacity: 0;
    }

    article div p {
      width: 50vw;
    }

    article div {
      max-height: calc(72%);
      overflow-y: auto;
    }
  }
}
</style>